import React, { useEffect, useState } from "react";
import LeftMenu from "./LeftMenu/leftMenu.js";
import NewHeader from "./Header/newHeader.jsx";
import { Outlet } from "react-router-dom";
import Breadcrumb from "../layouts/Breadcrumbs/Breadcrumb.js";
import { toggleAside, toggleTopbar } from "../../app/utils/utils.js";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../app/hooks/useAuth";

const BaseLayout = () => {
  const { user, logout } = useAuth();
  const dispatch = useDispatch();
  const { userAccountDetails } = useSelector((state) => state?.userDetailSlice);
  const [userLoginInfo, setUserLoginInfo] = useState(null);

  useEffect(() => {
    setUserLoginInfo(userAccountDetails?.userLoginInfo);
  }, [userAccountDetails]);
  return (
    <div
      id="kt_body"
      className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-fixed aside-enabled"
    >
      <div
        id="kt_header_mobile"
        className="header-mobile align-items-center  header-mobile-fixed "
      >
        <div className="d-flex align-items-center gap-3">
          <button
            className="btn p-0 back-icon burger-icon-left"
            id="kt_aside_mobile_toggle"
            onClick={toggleAside}
          >
            <span>
              <i className="fa-solid fa-arrow-left"></i>
            </span>
          </button>
        </div>

        <div className="d-flex align-items-stretch gap-1">
          <div className="dropdown-wrapper profile">
            <div className="dropdown-choose-wrapper">
              <div className="dropdown">
                <span className="dropdown-toggle " data-bs-toggle="dropdown">
                  <a href="void(0)" className="profile_pic">
                    {userLoginInfo?.first_name
                      ?.charAt(0)
                      .toUpperCase()
                      .slice(0, 1)}
                    {userLoginInfo?.last_name
                      ?.charAt(0)
                      .toUpperCase()
                      .slice(0, 1)}
                  </a>
                </span>
                <ul className="dropdown-menu">
                  <li>
                    <a
                      className="dropdown-item"
                      href="void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        logout();
                      }}
                    >
                      Log out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <button
              className="btn p-0 burger-icon burger-icon-right ml-4"
              id="kt_header_mobile_toggle"
              onClick={toggleTopbar}
            >
              <span></span>
            </button>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column flex-root min-h-100">
        <div className="page d-flex flex-row flex-column-fluid">
          <div className="aside aside-dark aside-hoverable">
            <div className="aside-logo flex-column-auto" id="kt_aside_logo">
              <a href="#">
                <img
                  src="../images/centric-logo.png"
                  alt="Centric"
                  className="h-25px logo"
                />
              </a>
            </div>
            <div className="aside-menu flex-column-fluid">
              <div className="hover-scroll-overlay-y aside-menu-wrapper">
                <LeftMenu />
              </div>
            </div>
            <div className="aside-footer flex-column-auto">
              <span>Copyright 2026 © Centric Fiber</span>
            </div>
          </div>
          <div className="wrapper d-flex flex-column flex-row-fluid">
            <NewHeader />

            <div className="content d-flex flex-column flex-column-fluid">
              <Breadcrumb />

              <div className="post d-flex flex-column-fluid">
                <div id="kt_content_container" className="">
                  <Outlet />
                  {/* <ChatComponent /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseLayout;
